// removed by extract-text-webpack-plugin
module.exports = {"carouselContainer":"_2616KlE1","carousel":"aype56TC","face":"_1ZD1_UkN","inner":"_2OrtCpaf"};


//////////////////
// WEBPACK FOOTER
// ./client/components/Carousel.styl
// module id = 646
// module chunks = 0